import { defaultTheme } from '@sleepstation/themes-public-site'
import { createTheme } from '@sleepstation/utils'

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

const noticeTheme = createTheme(
  `Notice`,
  defaultTheme.api,
  {
    colors: {
      background: `bluePale`,
      backgroundStart: `bluePale`,
      backgroundEnd: `bluePale`,
      border: `blueMidnightLighter`,
    },
  },
  defaultTheme
)

export default noticeTheme
